(function () {
  function initPolaroidSlider(section) {
    const track  = section.querySelector('.slider');
    const btnPrev = section.querySelector('.slider-btn--prev');
    const btnNext = section.querySelector('.slider-btn--next');

    if (!track) return;

    // ── Clone slides for infinite loop ──
    const originalSlides = Array.from(track.querySelectorAll('.slider-slide'));
    if (originalSlides.length < 2) return;

    // Prepend & append clones
    const clonesBefore = originalSlides.map(s => {
      const clone = s.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.classList.add('is-clone');
      return clone;
    });
    const clonesAfter = originalSlides.map(s => {
      const clone = s.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.classList.add('is-clone');
      return clone;
    });

    clonesBefore.reverse().forEach(c => track.prepend(c));
    clonesAfter.forEach(c => track.append(c));

    // All slides including clones
    const allSlides = () => Array.from(track.querySelectorAll('.slider-slide'));

    // ── Lazy load images in clones ──
    track.querySelectorAll('.is-clone img[loading="eager"]').forEach(img => {
      img.setAttribute('loading', 'lazy');
    });

    // ── Scroll to slide (instant = no animation) ──
    function scrollToSlide(index, instant = false) {
      const slides = allSlides();
      if (!slides[index]) return;
      const slideLeft = slides[index].offsetLeft;
      const centerOffset = (track.clientWidth - slides[index].offsetWidth) / 2;
      track.scrollTo({
        left: slideLeft - centerOffset,
        behavior: instant ? 'instant' : 'smooth'
      });
    }

            // ── Update active class ──
        function updateActive() {
        const slides = allSlides();
        const trackCenter = track.scrollLeft + track.clientWidth / 2;
        let closestIndex = 0;
        let closestDist = Infinity;

        slides.forEach((slide, i) => {
            const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
            const dist = Math.abs(trackCenter - slideCenter);
            if (dist < closestDist) {
            closestDist = dist;
            closestIndex = i;
            }
        });

        // Mittlerer + je 1 Nachbar links & rechts = aktiv
        slides.forEach((s, i) => {
            const isActive = i >= closestIndex - 1 && i <= closestIndex + 1;
            s.classList.toggle('is-active', isActive);
        });

        updateButtons();
        }

    // ── Infinite loop: jump without animation when hitting clones ──
    function handleLoop() {
      const slides = allSlides();
      const count = originalSlides.length;
      const cloneCount = count; // we cloned one full set each side

      // Currently closest slide index
      const trackCenter = track.scrollLeft + track.clientWidth / 2;
      let closestIndex = 0;
      let closestDist = Infinity;
      slides.forEach((slide, i) => {
        const dist = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - trackCenter);
        if (dist < closestDist) { closestDist = dist; closestIndex = i; }
      });

      // Jump to real slide if on clone
      if (closestIndex < cloneCount) {
        // On prepended clones → jump to matching real slide
        scrollToSlide(closestIndex + count, true);
      } else if (closestIndex >= cloneCount + count) {
        // On appended clones → jump to matching real slide
        scrollToSlide(closestIndex - count, true);
      }
    }

    // ── Arrow navigation ──
    function scrollByOne(dir) {
      const slides = allSlides();
      const trackCenter = track.scrollLeft + track.clientWidth / 2;
      let closestIndex = 0;
      let closestDist = Infinity;
      slides.forEach((slide, i) => {
        const dist = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - trackCenter);
        if (dist < closestDist) { closestDist = dist; closestIndex = i; }
      });
      scrollToSlide(closestIndex + dir);
    }

    btnPrev?.addEventListener('click', () => scrollByOne(-1));
    btnNext?.addEventListener('click', () => scrollByOne(1));

    // ── Button state (always enabled in loop) ──
    function updateButtons() {
      if (btnPrev) btnPrev.disabled = false;
      if (btnNext) btnNext.disabled = false;
    }

    // ── Scroll events ──
    let scrollTimer;
    track.addEventListener('scroll', () => {
      updateActive();
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(handleLoop, 150);
    }, { passive: true });

    // ── Random start within real slides ──
    function randomStart() {
      const count = originalSlides.length;
      const cloneCount = count;
      const randomIndex = cloneCount + Math.floor(Math.random() * count);
      scrollToSlide(randomIndex, true);
      updateActive();
    }

    // Init after layout is ready
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        randomStart();
      });
    });
  }

  function init() {
    document.querySelectorAll('.section-polaroid-slider').forEach(initPolaroidSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();